<template>
  <div class="ps-card-wrap">
    <div
      v-if="showSelectAll && list && list.length"
      class="ps-card-wrap__select-all"
    >
      <label class="ps-select-all" @click.stop>
        <input
          type="checkbox"
          :checked="isAllSelected"
          :indeterminate.prop="isIndeterminate"
          @change="$emit('select-all', $event.target.checked)"
        />
        <span>全选本页</span>
        <span v-if="selectedCount > 0" class="ps-select-all__count"
          >（已选 {{ selectedCount }}）</span
        >
      </label>
    </div>
    <div v-if="!list || !list.length" class="ps-empty">
      <div class="ps-empty__big">🗂</div>
      <div>{{ emptyText }}</div>
    </div>
    <div v-else class="ps-card-grid">
      <ProjectCard
        v-for="item in list"
        :key="item.id || item.applyId"
        :module-type="moduleType"
        :record="item"
        :request-count="getRequestCount(item)"
        :summary="getSummary(item)"
        :selectable="isItemSelectable(item)"
        :selected="isSelected(item)"
        @open="$emit('open', $event)"
        @preview="$emit('preview', $event)"
        @current="$emit('current', $event)"
        @history="$emit('history', $event)"
        @requests="$emit('requests', $event)"
        @select-change="onSelectChange"
      >
        <template #actions="slotProps">
          <slot name="actions" v-bind="slotProps"></slot>
        </template>
      </ProjectCard>
    </div>
  </div>
</template>

<script>
import ProjectCard from "./ProjectCard.vue";

export default {
  name: "ProjectCardGrid",
  components: { ProjectCard },
  props: {
    moduleType: {
      type: String,
      default: "studio",
    },
    list: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: "没有符合条件的项目",
    },
    requestCountKey: {
      type: String,
      default: "auditNum",
    },
    /** 是否展示全选 */
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    /** 返回某条是否可选，默认全部可选 */
    canSelectFn: {
      type: Function,
      default: null,
    },
  },
  computed: {
    selectableList() {
      return (this.list || []).filter((item) => this.isItemSelectable(item));
    },
    selectedCount() {
      return this.selectedIds.length;
    },
    isAllSelected() {
      const ids = this.selectableList.map((i) => i.id);
      return ids.length > 0 && ids.every((id) => this.selectedIds.includes(id));
    },
    isIndeterminate() {
      if (!this.selectedCount) return false;
      return !this.isAllSelected && this.selectableList.some((i) =>
        this.selectedIds.includes(i.id)
      );
    },
  },
  methods: {
    getRequestCount(item) {
      const n =
        item[this.requestCountKey] != null
          ? item[this.requestCountKey]
          : item.requestCount;
      return Number(n) || 0;
    },
    getSummary(item) {
      return item.summary || item.remark || "";
    },
    isItemSelectable(item) {
      if (!this.showSelectAll) return false;
      if (typeof this.canSelectFn === "function") {
        return !!this.canSelectFn(item);
      }
      return true;
    },
    isSelected(item) {
      return this.selectedIds.includes(item.id);
    },
    onSelectChange(record, checked) {
      this.$emit("select-change", record, checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.ps-card-wrap {
  background: transparent;
  &__select-all {
    display: flex;
    align-items: center;
    height: 36px;
    padding: 0 15px;
    margin-top: 8px;
  }
}
.ps-select-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  font-size: 14px;
  line-height: 1;
  color: #374151;
  cursor: pointer;
  user-select: none;
  margin: 0;
  input {
    width: 16px;
    height: 16px;
    margin: 0;
    padding: 0;
    flex-shrink: 0;
    cursor: pointer;
    vertical-align: middle;
  }
  span {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
  &__count {
    color: #2563eb;
  }
}
.ps-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 17px;
  padding: 12px 15px 20px;
}
.ps-empty {
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
  &__big {
    font-size: 40px;
    margin-bottom: 10px;
  }
}
</style>
